import(/* webpackMode: "eager" */ "C:\\pickeat\\pickeat_mall\\src\\app\\[locale]\\page.tsx");
